module.exports = __webpack_public_path__ + "static/media/21-8.b0bb084d.mp3";